import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";

import {
  addApprovalLevel,
  toggleApprovalLevelStatus,
  fetchApprovalLevels,
  fetchUserRoles,
  updateApprovalLevel,
} from "../services/apiService";

export default function ApprovalLevelsManager() {
  const [levels, setLevels] = useState([]);
  const [roles, setRoles] = useState([]);
  const [editingLevel, setEditingLevel] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [togglingLevel, setTogglingLevel] = useState(null);
  const [formData, setFormData] = useState({
    level_name: "",
    level_order: "",
    hiring_type: "",
  });
const [filters, setFilters] = useState({
  level_name: "",
  level_order: "",
  hiring_type: "",
  is_active: "",
});
  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [fetchedLevels, fetchedRoles] = await Promise.all([
        fetchApprovalLevels(),
        fetchUserRoles(),
      ]);
      setLevels(fetchedLevels);
      setRoles(fetchedRoles);
    } catch (err) {
      console.error("Error loading data", err);
      toast.error("Failed to load approval levels or roles.");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    const { level_name, level_order, hiring_type } = formData;

    if (!level_name || !level_order || !hiring_type) {
      toast.warn("Please fill in all required fields.");
      return;
    }

    try {
      if (editingLevel) {
        await updateApprovalLevel({
          approval_level_id: editingLevel.approval_level_id,
          level_name,
          level_order: Number(level_order),
          hiring_type,
        });
        toast.success("Approval level updated successfully.");
      } else {
        await addApprovalLevel({
          level_name,
          level_order: Number(level_order),
          hiring_type,
        });
        toast.success("Approval level added successfully.");
      }

      setFormData({ level_name: "", level_order: "", hiring_type: "" });
      setEditingLevel(null);
      setShowModal(false);
      loadData();
    } catch (err) {
      console.error("Error submitting form", err);
      toast.error("Failed to save approval level.");
    }
  };

  const handleEdit = (level) => {
    setEditingLevel(level);
    setFormData({
      level_name: level.level_name,
      level_order: level.level_order,
      hiring_type: level.hiring_type || "",
    });
    setShowModal(true);
  };

  const handleAddNew = () => {
    setEditingLevel(null);
    setFormData({ level_name: "", level_order: "", hiring_type: "" });
    setShowModal(true);
  };

  const handleToggleClick = (level) => {
    setTogglingLevel(level);
    setShowStatusModal(true);
  };

  const handleToggleConfirm = async () => {
    try {
      const newStatus = !togglingLevel.is_active;
      await toggleApprovalLevelStatus(togglingLevel.approval_level_id, newStatus);
      toast.success(`Approval level ${newStatus ? "activated" : "deactivated"} successfully.`);
      setShowStatusModal(false);
      setTogglingLevel(null);
      loadData();
    } catch (err) {
      console.error("Error toggling status", err);
      toast.error("Failed to update approval level status.");
    }
  };

  const inputStyle = {
    borderColor: "rgba(18, 76, 114, 0.3)",
    backgroundColor: "white",
  };

  const focusStyle = (e) => {
    e.target.style.boxShadow = "0 0 0 2px rgba(18, 76, 114, 0.2)";
    e.target.style.borderColor = "rgb(18, 76, 114)";
  };

  const blurStyle = (e) => {
    e.target.style.boxShadow = "none";
    e.target.style.borderColor = "rgba(18, 76, 114, 0.3)";
  };
const handleFilterChange = (e) => {
  const { name, value } = e.target;
  setFilters((prev) => ({ ...prev, [name]: value }));
};

const filteredLevels = levels.filter((level) => {
  return (
    (filters.level_name === "" || level.level_name?.toLowerCase().includes(filters.level_name.toLowerCase())) &&
    (filters.level_order === "" || String(level.level_order).includes(filters.level_order)) &&
    (filters.hiring_type === "" || level.hiring_type === filters.hiring_type) &&
    (filters.is_active === "" || String(level.is_active) === filters.is_active)
  );
});
  return (
    <div className="flex flex-col 2xl:px-[10%] pt-8 bg-white xl:pt-24 md:pt-8 md:rounded-t-[40px] xl:rounded-t-[48px] mx-4 h-[70vh] sm:h-[72vh] md:h-[74.5vh] lg:h-[74.5vh] xl:px-[calc(8%-1rem)] 3xl:px-[calc(8%-1rem)] 4xl:[padding-inline:calc(9.5%-1rem)] md:px-[calc(5%-1rem)]">
      <div className="bg-white rounded-2xl p-6 filter drop-shadow-[0_5px_30px_rgba(10,60,96,0.10)] h-[70vh] sm:h-[65vh] md:h-[68vh] lg:h-[63vh] xl:h-[90vh] overflow-y-auto relative -top-[160px]">
     <div className="flex flex-col sm:flex-col md:flex-row md:items-center md:gap-4 xl:gap-6 w-full">
  <h3 className="text-xl sm:text-2xl text-primary-800 font-semibold mb-4 md:mb-0">
    Approval Details
  </h3>
  <div className="flex flex-wrap sm:gap-4 md:flex-nowrap md:gap-4 ml-auto w-full md:w-auto">
    <button
      onClick={handleAddNew}
      className="w-full sm:w-auto md:w-auto bg-primary-800 text-white px-6 py-2 rounded-xl text-base xl:text-lg"
    >
      + Add New Level
    </button>
  </div>
</div>

{/* Filters */}
<div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-5">
  {/* Level Name Filter */}
  <div className="space-y-1">
    <label className="block text-xs font-medium" style={{ color: "rgb(18, 76, 114)" }}>
      Level Name
    </label>
    <input
      type="text"
      name="level_name"
      value={filters.level_name}
      onChange={handleFilterChange}
      placeholder="Search role..."
      className="w-full px-3 py-2 border rounded-lg outline-none text-sm text-gray-700 transition"
      style={{ borderColor: "rgba(18, 76, 114, 0.3)" }}
      onFocus={focusStyle}
      onBlur={blurStyle}
    />
  </div>

  {/* Level Order Filter */}
  <div className="space-y-1">
    <label className="block text-xs font-medium" style={{ color: "rgb(18, 76, 114)" }}>
      Level Order
    </label>
    <input
      type="number"
      name="level_order"
      value={filters.level_order}
      onChange={handleFilterChange}
      placeholder="e.g. 1, 2..."
      className="w-full px-3 py-2 border rounded-lg outline-none text-sm text-gray-700 transition"
      style={{ borderColor: "rgba(18, 76, 114, 0.3)" }}
      onFocus={focusStyle}
      onBlur={blurStyle}
    />
  </div>

  {/* Hiring Type Filter */}
  <div className="space-y-1">
    <label className="block text-xs font-medium" style={{ color: "rgb(18, 76, 114)" }}>
      Hiring Type
    </label>
    <select
      name="hiring_type"
      value={filters.hiring_type}
      onChange={handleFilterChange}
      className="w-full px-3 py-2 border rounded-lg outline-none text-sm text-gray-700 transition"
      style={{ borderColor: "rgba(18, 76, 114, 0.3)" }}
      onFocus={focusStyle}
      onBlur={blurStyle}
    >
      <option value="">All Types</option>
      <option value="Forecast">Forecast</option>
      <option value="Exceptional">Exceptional</option>
      <option value="Outsourced">Outsourced</option>
    </select>
  </div>

  {/* Status Filter */}
  <div className="space-y-1">
    <label className="block text-xs font-medium" style={{ color: "rgb(18, 76, 114)" }}>
      Status
    </label>
    <select
      name="is_active"
      value={filters.is_active}
      onChange={handleFilterChange}
      className="w-full px-3 py-2 border rounded-lg outline-none text-sm text-gray-700 transition"
      style={{ borderColor: "rgba(18, 76, 114, 0.3)" }}
      onFocus={focusStyle}
      onBlur={blurStyle}
    >
      <option value="">All Status</option>
      <option value="true">Active</option>
      <option value="false">Inactive</option>
    </select>
  </div>
</div>

{/* Active filters summary + Clear */}
{Object.values(filters).some((v) => v !== "") && (
  <div className="flex items-center justify-between mt-3 px-1">
    <p className="text-xs text-gray-500">
      Showing{" "}
      <span className="font-semibold" style={{ color: "rgb(18, 76, 114)" }}>
        {filteredLevels.length}
      </span>{" "}
      of {levels.length} records
    </p>
    <button
      onClick={() => setFilters({ level_name: "", level_order: "", hiring_type: "", is_active: "" })}
      className="text-xs font-medium px-3 py-1 rounded-lg border transition"
      style={{ color: "rgb(18, 76, 114)", borderColor: "rgba(18, 76, 114, 0.3)" }}
      onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "rgba(18, 76, 114, 0.1)"; }}
      onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "white"; }}
    >
      Clear Filters
    </button>
  </div>
)}

        {/* Table */}
        <div className="overflow-x-auto pt-6">
          <table className="min-w-full table-auto border-collapse">
            <thead className="bg-[#f5f3ef] text-primary-600 py-2 px-2 border-r border-primary-500/20 bg-primary-800/10 text-primary-800 text-left">
              <tr>
                <th className="py-3 px-4">Level Name</th>
                <th className="px-4">Level Order</th>
                <th className="px-4">Hiring Type</th>
                <th className="px-4">Status</th>
                <th className="px-4 text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredLevels.map((level, index) => (
                <tr
                  key={level.approval_level_id}
                  className={`${
                    index % 2 === 0 ? "bg-white" : "bg-primary-800/10"
                  } hover:bg-gray-50 transition border-b text-sm text-primary-600`}
                >
                  <td className="px-4 py-2 border-r text-[#232323]">{level.level_name}</td>
                  <td className="px-4 py-2 border-r text-[#232323]">{level.level_order}</td>
                  <td className="px-4 py-2 border-r text-[#232323]">
                    {level.hiring_type ? (
                      <span
                        className="px-2.5 py-1 rounded-full text-xs font-medium"
                        style={{
                          backgroundColor:
                            level.hiring_type === "Forecast"
                              ? "rgba(18, 76, 114, 0.1)"
                              : level.hiring_type === "Exceptional"
                              ? "rgba(234, 88, 12, 0.1)"
                              : "rgba(22, 163, 74, 0.1)",
                          color:
                            level.hiring_type === "Forecast"
                              ? "rgb(18, 76, 114)"
                              : level.hiring_type === "Exceptional"
                              ? "rgb(194, 65, 12)"
                              : "rgb(21, 128, 60)",
                        }}
                      >
                        {level.hiring_type}
                      </span>
                    ) : (
                      "—"
                    )}
                  </td>
                  <td className="px-4 py-2 border-r">
                    <span
                      className="px-2.5 py-1 rounded-full text-xs font-medium"
                      style={{
                        backgroundColor: level.is_active
                          ? "rgba(22, 163, 74, 0.1)"
                          : "rgba(220, 38, 38, 0.1)",
                        color: level.is_active
                          ? "rgb(21, 128, 60)"
                          : "rgb(185, 28, 28)",
                      }}
                    >
                      {level.is_active ? "Active" : "Inactive"}
                    </span>
                  </td>
                  <td className="px-4 py-3">
                    <div className="flex space-x-2 justify-center">
                      <button
                        onClick={() => handleEdit(level)}
                        className="bg-primary-800/10 hover:bg-primary-800 text-primary-800 hover:text-white px-4 py-2 rounded-lg flex items-center cursor-pointer transition-colors duration-200 text-sm font-medium border border-primary-800/20 hover:border-primary-800"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleToggleClick(level)}
                        className="px-4 py-2 rounded-lg flex items-center cursor-pointer transition-colors duration-200 text-sm font-medium border"
                        style={{
                          backgroundColor: level.is_active
                            ? "rgba(220, 38, 38, 0.05)"
                            : "rgba(22, 163, 74, 0.05)",
                          color: level.is_active
                            ? "rgb(185, 28, 28)"
                            : "rgb(21, 128, 60)",
                          borderColor: level.is_active
                            ? "rgba(220, 38, 38, 0.3)"
                            : "rgba(22, 163, 74, 0.3)",
                        }}
                      >
                        {level.is_active ? "Deactivate" : "Activate"}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {filteredLevels.length === 0 && (
                <tr>
                  <td colSpan={5} className="text-center text-gray-500 py-4">
                    No approval levels found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Add / Edit Modal */}
      {showModal && (
        <div
          className="fixed inset-0 backdrop-blur-sm flex justify-center items-center z-50 p-4"
          style={{ backgroundColor: "rgba(18, 76, 114, 0.2)" }}
        >
          <div
            className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl lg:max-w-3xl"
            style={{ borderColor: "rgba(18, 76, 114, 0.1)", borderWidth: "1px" }}
          >
            {/* Modal Header */}
            <div
              className="flex items-center justify-between p-6 border-b rounded-t-2xl"
              style={{
                borderColor: "rgba(18, 76, 114, 0.1)",
                background: "linear-gradient(to right, rgba(18, 76, 114, 0.05), transparent)",
              }}
            >
              <h2 className="text-xl font-semibold" style={{ color: "rgb(18, 76, 114)" }}>
                {editingLevel ? "Edit Approval Level" : "Add New Approval Level"}
              </h2>
              <button
                onClick={() => setShowModal(false)}
                className="transition-all rounded-full p-1.5"
                style={{ color: "rgba(18, 76, 114, 0.6)" }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "rgb(18, 76, 114)";
                  e.currentTarget.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                  e.currentTarget.style.color = "rgba(18, 76, 114, 0.6)";
                }}
                aria-label="Close"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-6 max-h-[60vh] overflow-y-auto">
              <div className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                  {/* Level Name (Role) */}
                  <div className="space-y-2">
                    <label className="block text-sm font-medium" style={{ color: "rgb(18, 76, 114)" }}>
                      Level Name (Role) <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="level_name"
                      value={formData.level_name}
                      onChange={handleChange}
                      className="w-full px-3 py-2.5 border rounded-lg outline-none transition text-gray-700"
                      style={inputStyle}
                      onFocus={focusStyle}
                      onBlur={blurStyle}
                    >
                      <option value="">Select Role</option>
                      {roles.map((role) => (
                        <option key={role.userRoles_id} value={role.role}>
                          {role.role}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Level Order */}
                  <div className="space-y-2">
                    <label className="block text-sm font-medium" style={{ color: "rgb(18, 76, 114)" }}>
                      Level Order <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="number"
                      name="level_order"
                      value={formData.level_order}
                      onChange={handleChange}
                      className="w-full px-3 py-2.5 border rounded-lg outline-none transition text-gray-700"
                      style={inputStyle}
                      onFocus={focusStyle}
                      onBlur={blurStyle}
                      placeholder="e.g., 1, 2, 3..."
                    />
                  </div>

                  {/* Hiring Type */}
                  <div className="space-y-2">
                    <label className="block text-sm font-medium" style={{ color: "rgb(18, 76, 114)" }}>
                      Hiring Type <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="hiring_type"
                      value={formData.hiring_type}
                      onChange={handleChange}
                      className="w-full px-3 py-2.5 border rounded-lg outline-none transition text-gray-700"
                      style={inputStyle}
                      onFocus={focusStyle}
                      onBlur={blurStyle}
                    >
                      <option value="">Select Hiring Type</option>
                      <option value="Forecast">Forecast</option>
                      <option value="Exceptional">Exceptional</option>
                      <option value="Outsourced">Outsourced</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div
              className="flex flex-col sm:flex-row justify-end gap-3 p-6 border-t rounded-b-2xl"
              style={{
                borderColor: "rgba(18, 76, 114, 0.1)",
                background: "linear-gradient(to right, transparent, rgba(18, 76, 114, 0.05))",
              }}
            >
              <button
                onClick={() => setShowModal(false)}
                className="px-5 py-2.5 bg-white border rounded-lg transition-all font-medium"
                style={{ color: "rgb(18, 76, 114)", borderColor: "rgba(18, 76, 114, 0.3)" }}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "rgba(18, 76, 114, 0.1)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "white"; }}
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                className="px-5 py-2.5 text-white font-medium rounded-lg transition-all"
                style={{
                  backgroundColor: "rgb(18, 76, 114)",
                  cursor: "pointer",
                  boxShadow: "0 10px 15px -3px rgba(18, 76, 114, 0.2)",
                }}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "rgba(18, 76, 114, 0.9)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "rgb(18, 76, 114)"; }}
              >
                {editingLevel ? "Update Level" : "Add Level"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Active / Inactive Confirmation Modal */}
      {showStatusModal && (
        <div
          className="fixed inset-0 backdrop-blur-sm flex justify-center items-center z-50 p-4"
          style={{ backgroundColor: "rgba(18, 76, 114, 0.2)" }}
        >
          <div
            className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md"
            style={{ borderColor: "rgba(18, 76, 114, 0.1)", borderWidth: "1px" }}
          >
            {/* Header */}
            <div
              className="flex items-center justify-between p-6 border-b rounded-t-2xl"
              style={{
                borderColor: "rgba(18, 76, 114, 0.1)",
                background: togglingLevel?.is_active
                  ? "linear-gradient(to right, rgba(220, 38, 38, 0.05), transparent)"
                  : "linear-gradient(to right, rgba(22, 163, 74, 0.05), transparent)",
              }}
            >
              <h2
                className="text-xl font-semibold"
                style={{ color: togglingLevel?.is_active ? "rgb(185, 28, 28)" : "rgb(21, 128, 60)" }}
              >
                {togglingLevel?.is_active ? "Deactivate" : "Activate"} Approval Level
              </h2>
              <button
                onClick={() => setShowStatusModal(false)}
                className="transition-all rounded-full p-1.5"
                style={{ color: "rgba(18, 76, 114, 0.6)" }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "rgb(18, 76, 114)";
                  e.currentTarget.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                  e.currentTarget.style.color = "rgba(18, 76, 114, 0.6)";
                }}
                aria-label="Close"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-6">
              <div className="flex items-start gap-4">
                <div
                  className="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center"
                  style={{
                    backgroundColor: togglingLevel?.is_active
                      ? "rgba(220, 38, 38, 0.1)"
                      : "rgba(22, 163, 74, 0.1)",
                  }}
                >
                  {togglingLevel?.is_active ? (
                    <svg className="w-5 h-5" style={{ color: "rgb(185, 28, 28)" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
                    </svg>
                  ) : (
                    <svg className="w-5 h-5" style={{ color: "rgb(21, 128, 60)" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                  )}
                </div>
                <div>
                  <p className="text-gray-700 font-medium">
                    Are you sure you want to{" "}
                    <span style={{ color: togglingLevel?.is_active ? "rgb(185, 28, 28)" : "rgb(21, 128, 60)" }}>
                      {togglingLevel?.is_active ? "deactivate" : "activate"}
                    </span>{" "}
                    <span className="font-semibold" style={{ color: "rgb(18, 76, 114)" }}>
                      {togglingLevel?.level_name}
                    </span>
                    ?
                  </p>
                  <p className="text-gray-500 text-sm mt-1">
                    {togglingLevel?.is_active
                      ? "This level will no longer be available in approval workflows."
                      : "This level will become available in approval workflows."}
                  </p>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div
              className="flex justify-end gap-3 p-6 border-t rounded-b-2xl"
              style={{ borderColor: "rgba(18, 76, 114, 0.1)" }}
            >
              <button
                onClick={() => setShowStatusModal(false)}
                className="px-5 py-2.5 bg-white border rounded-lg transition-all font-medium"
                style={{ color: "rgb(18, 76, 114)", borderColor: "rgba(18, 76, 114, 0.3)" }}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "rgba(18, 76, 114, 0.1)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "white"; }}
              >
                Cancel
              </button>
              <button
                onClick={handleToggleConfirm}
                className="px-5 py-2.5 text-white font-medium rounded-lg transition-all"
                style={{
                  backgroundColor: togglingLevel?.is_active ? "rgb(185, 28, 28)" : "rgb(21, 128, 60)",
                  cursor: "pointer",
                  boxShadow: togglingLevel?.is_active
                    ? "0 10px 15px -3px rgba(220, 38, 38, 0.2)"
                    : "0 10px 15px -3px rgba(22, 163, 74, 0.2)",
                }}
              >
                {togglingLevel?.is_active ? "Deactivate" : "Activate"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}